'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

    $('.nav').on('click', '.nav-trigger', function(){
        var elm = $(this);

        $(this).next().slideToggle(function(){
            elm.parent().toggleClass('nav--open');
        });

        return false;
    });


    $('.js-menu-toggle').on('click', function(){
        $('.mobile-navigation').toggleClass('has-mobile-nav');
        $("html").toggleClass("no-scroll");

        return false;
    });
}
